/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TradeApprovalListingStatus } from '../../models/trade-approval-listing-status';
import { TradeApprovalRequestListResponse } from '../../models/trade-approval-request-list-response';
import { TradeRequestStatus } from '../../models/trade-request-status';

export interface ListTradeScheduleRequests$Params {
  search?: string;

/**
 * Repeatable. Omitted or empty returns requests waiting for the caller now. INVALID returns requests disabled at a stage the caller may view; DISABLED is a deprecated alias of INVALID.
 */
  approvalStatus?: Array<TradeApprovalListingStatus>;

/**
 * Repeatable. Narrows the `approvalStatus` result.
 */
  status?: Array<TradeRequestStatus>;

/**
 * Repeatable. Keeps requests where any required base, fixed at submission, is any of these.
 */
  baseId?: Array<number>;

/**
 * Inclusive lower bound on the period start date.
 */
  periodStartFrom?: string;

/**
 * Inclusive upper bound on the period start date.
 */
  periodStartTo?: string;

/**
 * Inclusive lower bound on the period end date.
 */
  periodEndFrom?: string;

/**
 * Inclusive upper bound on the period end date.
 */
  periodEndTo?: string;

/**
 * `field,direction`. Field `submittedAt` (`createdAt` is accepted as the same value). Direction `asc` or `desc` (default `desc`). Ties keep request id order in the same direction. An unknown field or direction is a 400 (`errors.tradeSortInvalid`).
 */
  sort?: string;

/**
 * Zero-based page. A negative value returns 400 (`errors.tradePageInvalid`).
 */
  page?: number;
  size?: number;
}

export function listTradeScheduleRequests(http: HttpClient, rootUrl: string, params?: ListTradeScheduleRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<TradeApprovalRequestListResponse>> {
  const rb = new RequestBuilder(rootUrl, listTradeScheduleRequests.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('approvalStatus', params.approvalStatus, {"style":"form","explode":true});
    rb.query('status', params.status, {"style":"form","explode":true});
    rb.query('baseId', params.baseId, {"style":"form","explode":true});
    rb.query('periodStartFrom', params.periodStartFrom, {});
    rb.query('periodStartTo', params.periodStartTo, {});
    rb.query('periodEndFrom', params.periodEndFrom, {});
    rb.query('periodEndTo', params.periodEndTo, {});
    rb.query('sort', params.sort, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TradeApprovalRequestListResponse>;
    })
  );
}

listTradeScheduleRequests.PATH = '/api/scheduler/trade-schedule-requests';
